const COMPANIES = [
  {
    name: 'Sana Biotechnology',
    focus: 'Engineered cell and gene therapies',
    detail: 'Develops in vivo and ex vivo delivery platforms intended to repair, replace, or control specific cell types, spanning oncology, autoimmune disease, and genetic conditions.',
    calc: 'Relies on molarity dilution accuracy for viral vector titering and cell doubling time metrics during expansion of engineered cell banks.',
  },
  {
    name: 'Nautilus Biotechnology',
    focus: 'Single-molecule protein sequencing',
    detail: 'Builds platforms designed to identify and quantify proteins at single-molecule resolution, aiming to map the human proteome comprehensively.',
    calc: 'Depends on precise reagent dilution ratios and low-abundance analyte quantification consistent with standard lab calculation principles.',
  },
  {
    name: 'Vir Biotechnology',
    focus: 'Infectious disease & oncology antibodies',
    detail: 'Focuses on antibody and T-cell based therapeutics targeting viral infections such as hepatitis and influenza, plus select cancer indications.',
    calc: 'Uses qPCR copy number quantification for viral load monitoring and antibody titer validation across clinical development.',
  },
  {
    name: 'Ginkgo Bioworks',
    focus: 'Synthetic biology & organism engineering',
    detail: 'Operates a foundry model for programming cells across pharma, agriculture, and industrial biotechnology enzymatic synthesis applications.',
    calc: 'High-throughput strain screening requires exact molar dilution series and growth curve analysis via doubling time calculations.',
  },
  {
    name: 'Twist Bioscience',
    focus: 'Synthetic DNA manufacturing',
    detail: 'Produces synthetic DNA at scale for applications spanning gene synthesis, antibody libraries, and data storage research.',
    calc: 'DNA copy number and molar concentration calculations are core to quality control of synthesized oligo and gene fragment libraries.',
  },
  {
    name: 'Precision BioSciences',
    focus: 'Genome editing (ARCUS platform)',
    detail: 'Develops gene editing therapeutics and ex vivo allogeneic CAR-T cell therapies using its proprietary ARCUS nuclease platform.',
    calc: 'Cell doubling time tracking is critical for characterizing edited cell line proliferation kinetics prior to clinical banking.',
  },
]

function BiotechDirectory() {
  return (
    <section aria-labelledby="directory-heading" className="max-w-4xl">
      <h1 id="directory-heading" className="text-3xl font-extrabold text-slate-900 mb-2">
        Biotech Directory: Industry Profiles
      </h1>
      <p className="text-slate-600 leading-relaxed mb-8 max-w-2xl">
        A curated reference of biotechnology companies, the therapeutic or platform areas they operate in, and how core laboratory calculations, such as molarity dilution, cell doubling time, and qPCR copy number, feed directly into their research and drug discovery pipelines.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        {COMPANIES.map(company => (
          <article
            key={company.name}
            className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm hover:shadow-md transition-shadow"
          >
            <h2 className="text-lg font-bold text-slate-900 mb-1">{company.name}</h2>
            <p className="text-xs font-semibold uppercase tracking-wide text-emerald-700 mb-3">{company.focus}</p>
            <p className="text-sm text-slate-700 leading-relaxed mb-3">{company.detail}</p>
            <div className="border-t border-slate-100 pt-3">
              <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-1">Lab Calculation Relevance</p>
              <p className="text-sm text-slate-600 leading-relaxed">{company.calc}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  )
}

export default BiotechDirectory
